import React from "react"
import { useEffect, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { TextField, Button, Autocomplete, Box, Typography } from "@mui/material"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import {
  ApiAddAreaManager,
  ApiGetClientDbName,
  ApiGetClientEntityListById,
  ApiGetClients,
  ApiGetManageRegions,
  ApiGetRegionBusinessDetails,
  ApiGetVenueList,
  ApiPostRegionBusinessDetail,
  ApiUpdateAreaManager,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import PatchedReactQuill from "../ManageVenue/PatchedReactQuill.tsx"
import RegionBusinessDetails from "./RegionBusinessDetails.tsx"

interface AreaFormProps {
  initialValues?: {
    areaName: string
    userName: string
    password: string
    venueList: string[]
    email: string
  }
  onSubmit: (values: any) => void
  mode: "add" | "update"
}
const AddOrEditRegionBusinessDetails: React.FC<AreaFormProps> = ({
  initialValues = {
    areaName: "",
    userName: "",
    password: "",
    venueList: [],
    email: "",
  },
  onSubmit,
}) => {
  interface Region {
    label: string;
    value: number;
  }

  const location = useLocation()
  // const reportBusinessDetails = location?.state?.reportBusinessDetails
  const [reportBusinessDetails, setRegionBusinessDetails] = useState<any>([])
  const [venues, setVenues] = useState<any[]>([])
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const { mode, id } = useParams<{ mode: "add" | "update"; id?: string }>()
  const [clientGroupOptions, setClientGroupOptions] = useState([])
  const [clientOptions, setClientOptions] = useState<any[]>([])
  const [selectedClientGroup, setSelectedClientGroup] = useState()
  const [clientEntities, setClientEntities] = useState([])
  const [clientId, setClientId] = useState<string | null>(null)
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)
  const [regions, setRegions] = useState<Region[]>([]);
  const [regionId, setRegionId] = useState<any>(null);
  const [reportMessage, setReportMessage] = useState("");

  const fetchRegionBusinessDetails = async () => {
      try {
        const data =`?clientEntityRegionReportId=${id}`
        const response = await ApiGetRegionBusinessDetails(data);
        setRegionBusinessDetails(response.data[0]);
      } catch (error) {
        console.error("Error fetching area managers:", error);
      }
    };
  
    useEffect(() => {
      fetchRegionBusinessDetails();
    }, []);

  useEffect(() => {
    if (mode === "update" && id) {
      console.log(`Fetching data for area with ID: ${id}`)
      // Here you would fetch the area manager data for editing
      // Example: fetchreportBusinessDetailsById(id);
    }
  }, [mode, id])

  useEffect(() => {
    if (mode === "update" && id) {
      console.log(`Fetching data for client with ID: ${id}`)
    }
    handleCallGetClientDbName()
    handleGetRegions()
  }, [mode, id])

  useEffect(() => {
    if (reportBusinessDetails && mode === "update") {
      setReportMessage(reportBusinessDetails?.reportMessage);
      // Find and set client group
      if (reportBusinessDetails?.clientEntityId?.clientId) {
        const clientGroup: any = clientGroupOptions.find((group:any) => group.clientGroupName === reportBusinessDetails?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName)
        if (clientGroup) {
          setSelectedClientGroup(clientGroup)
          fetchClientsByGroup(clientGroup.clientGroupName)
        }
      }
      // Set client ID
      if (reportBusinessDetails.clientEntityId?.clientId.ClientID) {
        setClientId(reportBusinessDetails.clientEntityId?.clientId.ClientID)
        fetchBusinessesByClient(reportBusinessDetails.clientEntityId?.clientId.ClientID)
      }

      // Set client entity ID
      if (reportBusinessDetails?.clientEntityId) {
        setClientEntityId(reportBusinessDetails.clientEntityId.clientEntityId)
        fetchVenues(reportBusinessDetails.clientEntityId.clientEntityId)
      }
      setRegionId(reportBusinessDetails?.regionId?.regionId);
    }
  }, [reportBusinessDetails, mode, clientGroupOptions])

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      const formData = {
        clientEntityId: clientEntityId,
        regionId: regionId,
        reportMessage: reportMessage,
        createdBy: Number(localStorage.getItem('createdBy'))
      }

      setLoading(true)
      setError(null)

      try {
        if (mode === "add") {
          console.log(formData)
          // Call API to add a new area manager
          const response = await ApiPostRegionBusinessDetail(formData)
          toast.success("Region Business report message added successfully!")
          navigate(-1) // Redirect to the area managers list page
        } else if (mode === "update" && id) {
          const data = {
            clientEntityRegionReportId: reportBusinessDetails.clientEntityRegionReportId,
            clientEntityId: clientEntityId,
            regionId: regionId,
            reportMessage: reportMessage,
            createdBy: Number(localStorage.getItem('createdBy'))
          }
          // Call API to update an existing area manager
          await ApiPostRegionBusinessDetail(data);
          toast.success("Region Business report message updated successfully!")
          navigate(-1) // Redirect to the area managers list page
        }
      } catch (error:any) {
        console.error("Error during API call:", error)
        setError(error?.response?.data.message || "An error occurred")
        toast.error(error?.response?.data.message || "Failed to save details")
      } finally {
        setLoading(false)
      }
    },
  })

  const handleGetRegions = async () => {
      try {
        const response: any = await ApiGetManageRegions();
        const transformed = response.data.map((item: any) => ({
          value: item.regionId,
          label: item.regionName,
        }));
        setRegions(transformed);
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };
    console.log(regions)

  const handleCallGetClientDbName = async () => {
    try {
      {
        const response = await ApiGetClientDbName()
        setClientGroupOptions(response.data)
      }
    } catch (error) {
      console.error("Error during API call:", error)
      toast.error(`${error}`)
    }
  }

  const fetchBusinessesByClient = async (clientId: any) => {
    const data = `?clientId=${clientId}&clientEntityStatus=active`
    try {
      const response: any = await ApiGetClientEntityListById(data)
      setClientEntities(response.data)
      console.log("Business response:", response.data)
    } catch (error) {
      console.error("Failed to fetch businesses:", error)
      toast.error("Failed to fetch businesses")
    }
  }

  console.log(venues)

  const fetchClientsByGroup = async (clientGroup: string) => {
    const data = `?status=active&clientGroup=${clientGroup}`
    try {
      const response = await ApiGetClients(data)

      setClientOptions(response.data)
    } catch (error) {
      console.error("Failed to fetch clients:", error)
      toast.error("Failed to fetch clients")
    }
  }
  console.log(clientOptions);

  const fetchVenues = async (clientEntityId:any) => {
    try {
      const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`
      const res = await ApiGetVenueList(data)
      setVenues(res.data) // Ensure options are set correctly
    } catch (error) {
      console.error("Error fetching venues:", error)
    }
  }

  return (
    <Box className='w-100 p-2'>
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 800,
        margin: "auto",
        padding: 3,
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography className="text-center fs-42">{mode === "add" ? "Add Region Business Detail" : "Update Region Business Detail"}</Typography>

      <div>
        <Autocomplete
          options={clientGroupOptions}
          value={
            selectedClientGroup ||
            (reportBusinessDetails?.clientGroup
              ? clientGroupOptions.find((option: any) => option.clientGroupName === reportBusinessDetails.clientGroup)
              : null)
          }
          getOptionLabel={(option: any) => option?.clientGroupName || ""}
          onChange={(event, newValue) => {
            setSelectedClientGroup(newValue)
            if (newValue) {
              fetchClientsByGroup(newValue.clientGroupName)
            } else {
              setClientOptions([])
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client Group" />}
          fullWidth
        />
      </div>
      <div>
        <Autocomplete
          options={clientOptions}
          value={clientId ? clientOptions.find((option) => option.ClientID === clientId) : null}
          getOptionLabel={(option) => option?.ClientName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientId(newValue.ClientID)
              fetchBusinessesByClient(newValue.ClientID)
            } else {
              setClientId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client" />}
          fullWidth
        />
      </div>
      <div>
        <Autocomplete
          options={clientEntities}
          value={clientEntityId ? clientEntities.find((option: any) => option.clientEntityId === clientEntityId) : null}
          getOptionLabel={(option: any) => option?.entityName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientEntityId(newValue.clientEntityId)
              fetchVenues(newValue.clientEntityId)
            } else {
              setClientEntityId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Business" />}
          fullWidth
        />
      </div>
      <div>
        <Autocomplete
          options={regions}
          value={regionId ? regions?.find((option: Region) => option.value === regionId) : null}
          getOptionLabel={(option: Region) => option?.label || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setRegionId(newValue.value)
            } else {
              setRegionId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Region" />}
          fullWidth
        />
      </div>

      <label>Report Message</label>
        <PatchedReactQuill
          setEditorValue={setReportMessage}
          editorValue={reportMessage}
          isUpdate={false}
        />

      <div  style={{ color: "red" }} className="mb-5">{error}</div>
      <Button type="submit" variant="contained" color="primary" className="table-row-background" disabled={loading}>
        {loading ? "Saving..." : mode === "add" ? "Add Details" : "Update Details"}
      </Button>
    </Box>
    </Box>
  )
}

export default AddOrEditRegionBusinessDetails
